import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { messages } from './AcceptTouForm.i18n';

class AcceptTouForm extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.state = {
      accepted: false,
      errorDisplayed: false,
    };
    this.onAcceptClick = this.onAcceptClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount = () => {
    // To control browser's back button click
    window.onpopstate = this.onCancelClick;
  };

  onAcceptClick = (event) => {
    event.preventDefault();
    if (this.state.accepted) {
      this.props.handleAcceptTou();
    } else {
      this.setState({ errorDisplayed: true });
    }
  };

  onCancelClick = (event) => {
    event.preventDefault();
    this.props.handleCancel();
  };

  handleChange = () => {
    this.setState({ accepted: !this.state.accepted });
    this.setState({ errorDisplayed: false });
  };

  render() {
    return (
      <div className="col-md-8 col-sm-12 col-md-offset-2">
        <div className="panel panel-default description-box reset notheme">
          <div className="panel-body">
            <div className="content-area">
              <p tabIndex="0" data-qa-item="touAcceptBelowHint"><FormattedMessage {...messages.required.hint} /></p>
              <div className="spacer small"></div>
              <div className="clearfix scrollbox" tabIndex="0">
                <div data-qa-item="touContent" dangerouslySetInnerHTML={{ __html: this.props.touContent }}></div>
              </div>
              <div className="spacer small"></div>
              <form onSubmit={this.onAcceptClick}>
                <div className="checkbox tou">
                  <label data-qa-item="touDeclareLabel">
                    <input type="checkbox" onChange={this.handleChange} checked={this.state.checked} />
                    <FormattedMessage {...messages.declare.label} />
                  </label>
                </div>
                {
                  this.state.errorDisplayed ?
                  <div className="alert alert-danger" role="alert" data-qa-item="continueWOAcceptError">
                    <FormattedMessage {...messages.declare.error} />
                  </div> :
                    null
                }
                <div className="spacer tiny"></div>
                <div className="button-area">
                  <a type="button" className="btn btn-lg btn-primary" data-qa-item="continueButton"
                    onClick={this.onAcceptClick}
                    href="#" role="button"
                  ><FormattedMessage {...messages.buttons.continue} />
                  </a>
                  <a type="button" className="btn btn-lg btn-link" data-qa-item="cancelButton"
                    onClick={this.onCancelClick}
                    href="#"
                  ><FormattedMessage {...messages.buttons.cancel} />
                  </a>
                </div>
              </form>
              <div className="spacer medium"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AcceptTouForm.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleAcceptTou: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  touContent: PropTypes.string,
};

const mapStateToProps = (state) => ({
  touContent: state.profile.user.termsOfUse,
});


export default connect(mapStateToProps)(AcceptTouForm);